<!--
  A Bulma-styled save button, with loading spinner
-->
<template>
  <div class="field" style="text-align: right">
    <div class="control is-small">
      <button type="submit" value="Save" class="formButton button is-link" :class="{ 'is-small': !large, 'is-loading': action && (inProgressAction == action) }" @click="onClick()">
        <i v-if="icon && !iconRight" class="fa mr-2" :class="icon"></i>
        <span>{{ label ? label : 'Save' }}</span>
        <i v-if="icon && iconRight" class="fas ml-2" :class="icon"></i>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>

defineProps<{
  action?: string,
  inProgressAction?: string,
  label?: string,
  icon?: string,
  iconRight?: boolean,
  large?: boolean
}>();

// Event for two-way binding
const emit = defineEmits(['click'])
const onClick = () => {
  emit('click');
};
</script>

<style scoped>
</style>